import type { Nudge } from '../types';

interface PeopleNudgeBadgeProps {
  nudge: Nudge;
}

const urgencyStyles: Record<Nudge['urgency'], string> = {
  high: 'bg-error-bg text-error border-error/30',
  medium: 'bg-warning-bg text-warning border-warning/30',
  low: 'bg-info-bg text-info border-info/30',
};

export function PeopleNudgeBadge({ nudge }: PeopleNudgeBadgeProps) {
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold border ${urgencyStyles[nudge.urgency]}`}
      title={nudge.talking_point}
    >
      <span className="material-icons-round" style={{ fontSize: '12px' }}>notifications_active</span>
      {nudge.urgency} follow-up
    </span>
  );
}

export default PeopleNudgeBadge;
